import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=4a00ad52&scoped=true"
import script from "./Modulos.vue?vue&type=script&lang=js"
export * from "./Modulos.vue?vue&type=script&lang=js"
import style0 from "./Modulos.vue?vue&type=style&index=0&id=4a00ad52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00ad52",
  null
  
)

export default component.exports